















































































import Vue from "vue";
import { createNamespacedHelpers } from "vuex";

import expenseStoreModule from "@/store/modules/expense";
import employeeStoreModule from "@/store/modules/employee";
import { Business, Expense, Role } from "@/types";
import ExpenseForm from "./ExpenseForm.vue";

const { mapActions: employeeActions, mapGetters: employeeGetters } =
  createNamespacedHelpers("EXPENSE_EMPLOYEE_");

const { mapActions: expenseActions, mapGetters: expenseGetters } =
  createNamespacedHelpers("EXPENSE_");

const API_URL = process.env.VUE_APP_API_URL;

export default Vue.extend<any, any, any, any>({
  components: { ExpenseForm },
  name: "ExpenseList",
  data: () => ({
    showDialog: false,
    selectedStaff: "All staff",
    expense: undefined as undefined | Expense,
    appUrl: API_URL,
    headers: [
      {
        text: "Name",
        align: "start",
        sortable: true,
        value: "name",
      },
      { text: "Type", value: "type" },
      { text: "Amount", value: "amount" },
      { text: "Date", value: "date" },
      { text: "Staff", value: "employee" },
      { text: "Payment", value: "paymentMethod" },
      { text: "Receipt", value: "receiptPhoto" },
      { text: "Description", value: "description" },
    ],
    options: {} as { page: number },
    employeeId: undefined as string | undefined,
  }),
  watch: {
    role() {
      if (this.role) {
        this.fetchExpenses();
        const bid = (this.role.business as Business)._id;
        this.fetchEmployeeList(`?businessId=${bid}&page=1`);
      }
    },
    options: {
      handler() {
        this.fetchExpenses();
      },
      deep: true,
    },
    employeeId() {
      this.searchExpense();
    },
  },
  computed: {
    ...expenseGetters(["expensePage"]),
    ...employeeGetters(["employeePage"]),
    role(): Role {
      return this.$store.getters.role;
    },
  },
  created() {
    if (this.role) {
      this.fetchExpenses();
      const bid = (this.role.business as Business)._id;
      this.fetchEmployeeList(`?businessId=${bid}&page=1`);
    }
  },
  methods: {
    ...expenseActions(["fetchExpenseList"]),
    ...employeeActions(["fetchEmployeeList"]),
    viewExpense(expense: Expense): void {
      this.expense = expense;
    },
    exportCsv() {
      if (!this.expensePage.docs || !this.expensePage.docs.length) {
        console.error("No expenses to export");
        return;
      }

      const data = this.expensePage.docs.map((x) => ({
        Name: x.name || "",
        Type: x.type || "",
        Amount: x.amount || "0",
        Date: this.$options.filters?.readableDate(x.date, "DD MMM YYYY") || "",
        Staff: x.employee?.fullName || "",
        "Payment Method": (x.paymentMethod || "").toUpperCase(),
        Description: x.description || "",
      }));

      this.downloadCsv(
        data,
        `expenses_${new Date().toISOString().split("T")[0]}.csv`
      );
    },
    downloadCsv(data: Record<string, string>[], filename = "export.csv") {
      const headers = Object.keys(data[0]);
      const csvRows = [
        headers.join(","),
        ...data.map((row) =>
          headers
            .map((header) => {
              const cell = row[header];
              if (
                typeof cell === "string" &&
                (cell.includes(",") || cell.includes('"'))
              ) {
                return `"${cell.replace(/"/g, '""')}"`;
              }
              return cell?.toString() ?? "";
            })
            .join(",")
        ),
      ];

      const csvContent = csvRows.join("\n");
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.setAttribute("href", url);
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    },
    fetchExpenses() {
      if (this.role) {
        const params = `?businessId=${
          (this.role.business as Business)._id
        }&page=${this.options.page || 1}`;
        this.fetchExpenseList(params);
      }
    },
    searchExpense(q = "") {
      const bid = (this.role.business as Business)._id;
      const page = this.options.page || 1;
      let params = `?businessId=${bid}&page=${page}&limit=10`;
      if (this.employeeId) {
        params += `&employeeId=${this.employeeId}`;
      }
      if (q && q.length > 2) {
        params += `&q=${q}`;
      }
      this.fetchExpenseList(params);
    },
    searchEmployee(q: string) {
      let params = `?businessId=${(this.role.business as Business)._id}&page=1`;
      if (q && q.length > 2) {
        params += `&q=${q}`;
      }
      this.fetchEmployeeList(params);
    },
  },
  beforeCreate() {
    if (!this.$store.hasModule("EXPENSE_")) {
      this.$store.registerModule("EXPENSE_", expenseStoreModule);
    }
    if (!this.$store.hasModule("EXPENSE_EMPLOYEE_")) {
      this.$store.registerModule("EXPENSE_EMPLOYEE_", employeeStoreModule);
    }
  },
  beforeDestroy() {
    this.$store.unregisterModule("EXPENSE_");
    this.$store.unregisterModule("EXPENSE_EMPLOYEE_");
  },
});
